import { render, staticRenderFns } from "./workload-affiliate-requests.vue?vue&type=template&id=4f4cdbb0&scoped=true&"
import script from "./workload-affiliate-requests.vue?vue&type=script&lang=js&"
export * from "./workload-affiliate-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cdbb0",
  null
  
)

export default component.exports